import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, Subject } from 'rxjs';
import { map, tap } from 'rxjs/operators';
import { ApiResponse } from '@core/models/api-response.model';
import { LogoFavicon } from '@core/models/logo-favicon.model';
import { Pagination } from '@core/models/pagination.model';

export interface LogoFaviconList {
  default: LogoFavicon[];
  seasonal: LogoFavicon[];
}

@Injectable()
export class LogoFaviconHttpService {

  pagination: Pagination;
  messages$ = new Subject<any[]>();

  constructor(private http: HttpClient) { }

  getWithQuery(pageParam: string): Observable<LogoFaviconList> {
    return this.http.get<ApiResponse>(`/logofavicon${pageParam}`).pipe(
      tap(res => this.pagination = res.data.seasonal.paginations),
      map(res => ({
        default: res.data.default || [],
        seasonal: res.data.seasonal.rows || [],
      }))
    );
  }

  add(body: any): Observable<ApiResponse> {
    return this.http.post<ApiResponse>('/logofavicon', body).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  update(id: number, body: any): Observable<ApiResponse> {
    return this.http.put<ApiResponse>(`/logofavicon/${id}`, body).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }

  updateStatus(id: number, status: number): Observable<ApiResponse> {
    return this.http.put<ApiResponse>('/logofavicon/statusupdate', { id, status }).pipe(
      tap(res => this.messages$.next(res.message))
    );
  }
}
